<script>
export default {
  name: "SortableHeader.vue",
  props: ['column', 'selectedColumn', 'sortDirection']
}
</script>

<template>
  <div>
    <slot></slot>
    <template v-if="column === selectedColumn">
      <i v-if="sortDirection === 'asc'" class="fa fa-sort-amount-asc" aria-hidden="true"></i>
      <i v-else class="fa fa-sort-amount-desc" aria-hidden="true"></i>
    </template>
    <template v-else>
      <i class="fa fa-sort" aria-hidden="true"></i>
    </template>
  </div>

</template>

<style scoped>

</style>
